export default {
  svgData: [
    {
      id: "slide6tablet1",
      name: "Tablet",
      url:
        "https://0013915-gdot.hub.arcgis.com/app/529b90d5d1cf4cb69c4b8d0104d1b450",
      label: "slide6tablet1"
    },
    {
      id: "slide6display1",
      name: "Display",
      url:
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/phoh/eic-comment-card.pdf",
      label: "slide6display1"
    },
    {
      id: "slide6avatar1",
      name: "Avatar"
    },
    {
      id: "slide6bubble1",
      label: "slide6bubble1"
    },
    {
      id: "slide6bubble2", // placeholder for time-triggered text
      label: "slide6bubble2"
    },
    {
      id: "slide6bubble3", // placeholder for time-triggered text
      label: "slide6bubble3"
    }
  ],
  slideTitle: "Live Event/Comment Station",
  aboutText: `
    <p class="text-justify help">
    We hope that the information provided in this virtual space answered many of your 
    questions and you learned more about the proposed I-285/I-20 East Interchange Project.
    </p>
    <p class="text-justify help">
    Remember to review and submit comments on the following documents found in the space: 
    </p>
    <ul class="text-justify help">
      <li>
      <b>Draft Environmental Assessment</b> (located in the Environmental Impacts station)
      </li>
      <li>
      <b>Project Concept Display</b> (located in the Project Design station)
      </li>
    </ul>
  <br>
  <p class="text-justify help">
  <b>Comments must be submitted by Thursday, September 24, 2020</b>. You can provide comments by using any of the following methods:
  </p>
  <ul class="text-justify help">
    <li>
    Click the tablet on the table at this station to complete an <b>online survey</b>
    </li>
    <li>
    Click the handout to <b>print a hard copy</b> of a comment response form
    </li>
  </ul>
  <br>
  <p class="text-justify help">
  If you choose to submit a hard copy form, you can either email the form to us at 
  <a href="mailto:eastinterchange@dot.ga.gov ">eastinterchange@dot.ga.gov </a> or 
  submit through U.S. Mail to:  
  </p>
   <ul style="font-size: larger; list-style-type:none;" class="text-left">
    <li> 
    Mr. Eric Duff
    </li>
    <li> 
    State Environmental Administrator
    </li>
    <li> 
    Georgia Department of Transportation
    </li>
    <li> 
    600 West Peachtree Street, NW – 16th Floor
    </li>
    <li> 
    Atlanta, Georgia 30308
    </li>
  </ul>
  <br>
  <p class="text-justify help">
  If you have additional questions, we invite you to participate in the Call-in Question and Answer session on September 3, 2020 from 5:30 p.m. to 7:30 p.m.
  </p>

    `,
  helpText: `
    <p class="text-justify help">
      Thank you for visiting our interactive I-285/I-20 East Interchange Project virtual meeting room. 
    </p>
    <p class="text-justify help">
    Before you leave, please be sure to review and submit comments on the following documents found in the space:
    </p>
    <ul class="text-justify help">
      <li>
      <b><u>Draft Environmental Assessment</b></u> (located in the Environmental Impacts station)
      </li>
      <li>
      <b><u>Concept Display</b></u> (located in the Project Design station)
      </li>
    </ul>
    <br>
    <p class="text-justify help">
    Your comments are important to us! <b>Comments must be submitted by Thursday, September 24, 2020.</b>
    </p>  

    <p class="text-justify help">
    <b>Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> 
    to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> 
    to see this message again after you close it out</b>.
    </p>
    <p class="text-justify help">
    This concludes the tour of the virtual meeting room. Feel free to navigate back to other stations in the meeting space. If you need further information, please call into the Question and Answer Session on September 3, 2020 from 5:30 to 7:30 p.m. </p>
    `
};
